import "./RelatorioPesquisaDespesas.scss";
import { DataGrid } from "@mui/x-data-grid";

// const formatarMoeda = (valor) =>
//   new Intl.NumberFormat("pt-CV", {
//     style: "currency",
//     currency: "CVE",
//     minimumFractionDigits: 2,
//   }).format(valor ?? 0);

const formatarMoeda = (valor) => valor.toLocaleString("pt-Br") + "$00";

const formatarData = (data) => {
  if (!data) return "—";
  return new Date(data).toLocaleDateString("pt-PT");
};

function RelatorioPesquisaDespesasResultado({ dados }) {
  const { despesas = [], total = 0, totalPagas = 0, totalNaoPagas = 0 } = dados;

  if (despesas.length === 0) {
    return (
      <div className="relatorio-despesas__resultado">
        <p className="relatorio-despesas__vazio">
          Nenhuma despesa encontrada para os filtros selecionados.
        </p>
      </div>
    );
  }

  return (
    <div className="relatorio-despesas__resultado">
      {/* Totais */}
      <div className="relatorio-despesas__totais">
        <div className="relatorio-despesas__total-card">
          <span className="relatorio-despesas__total-card__label">
            Total Geral
          </span>
          <span className="relatorio-despesas__total-card__valor">
            {formatarMoeda(total)}
          </span>
        </div>
        <div className="relatorio-despesas__total-card relatorio-despesas__total-card--pago">
          <span className="relatorio-despesas__total-card__label">
            Total Pago
          </span>
          <span className="relatorio-despesas__total-card__valor">
            {formatarMoeda(totalPagas)}
          </span>
        </div>
        <div className="relatorio-despesas__total-card relatorio-despesas__total-card--nao-pago">
          <span className="relatorio-despesas__total-card__label">
            Total Não Pago
          </span>
          <span className="relatorio-despesas__total-card__valor">
            {formatarMoeda(totalNaoPagas)}
          </span>
        </div>
        <div className="relatorio-despesas__total-card relatorio-despesas__total-card--count">
          <span className="relatorio-despesas__total-card__label">
            Nº de Despesas
          </span>
          <span className="relatorio-despesas__total-card__valor">
            {despesas.length}
          </span>
        </div>
      </div>

      {/* Tabela */}
      {/* DataGrid */}
      <div style={{ width: "100%", height: "650px" }}>
        <DataGrid
          pageSize={10}
          rowsPerPage={10}
          rows={despesas}
          getRowId={(row) => row._id}
          columns={[
            {
              field: "created_at",
              headerName: "Data Criação",
              width: 120,
              renderCell: (params) => formatarData(params.value),
            },
            {
              field: "descricao",
              headerName: "Descrição",
              flex: 1,
              minWidth: 160,
              renderCell: (params) =>
                params.value || params.row.observacoes || "—",
            },
            {
              field: "categoria",
              headerName: "Categoria",
              width: 180,
              renderCell: (params) => params.value?.categoria || "—",
            },
            {
              field: "caixa",
              headerName: "Caixa",
              width: 120,
              renderCell: (params) => params.value?.caixa || "—",
            },
            {
              field: "fornecedor",
              headerName: "Fornecedor",
              width: 150,
              renderCell: (params) => params.value?.nome || "—",
            },
            {
              field: "funcionario",
              headerName: "Funcionário",
              width: 150,
              renderCell: (params) =>
                params.value?.nome || params.row.funcionarioUser?.name || "—",
            },
            {
              field: "cliente",
              headerName: "Cliente",
              width: 150,
              renderCell: (params) => params.value?.nome || "—",
            },
            {
              field: "metodoPagamento",
              headerName: "Método Pagamento",
              width: 160,
              renderCell: (params) => params.value || "—",
            },
            {
              field: "dataPagamento",
              headerName: "Data Pagamento",
              width: 130,
              renderCell: (params) => formatarData(params.value),
            },
            {
              field: "despesaPaga",
              headerName: "Estado",
              width: 110,
              renderCell: (params) => (
                <span
                  className={`relatorio-despesas__badge ${params.value ? "relatorio-despesas__badge--pago" : "relatorio-despesas__badge--pendente"}`}
                >
                  {params.value ? "Pago" : "Pendente"}
                </span>
              ),
            },
            {
              field: "valor",
              headerName: "Valor",
              width: 130,
              align: "right",
              headerAlign: "right",
              renderCell: (params) => formatarMoeda(params.value),
            },
          ]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          pageSizeOptions={[10, 25, 50]}
          disableRowSelectionOnClick
          getRowClassName={(params) =>
            params.row.despesaPaga ? "" : "relatorio-despesas__linha--pendente"
          }
          sx={{ border: 0 }}
        />
      </div>
    </div>
  );
}

export default RelatorioPesquisaDespesasResultado;
